<template lang="pug">
  #best-price
    .overlay
      .content
        .text
          h2.title Você sabia que nós temos o melhor preço?
          p.description Estamos sempre preocupado com a sua satisfação com nossos serviços, por isso temos a maior qualidade e os menores preços!
          //- button Fazer Orçamento
</template>

<script>
export default {
  name: 'BestPrice'
}
</script>

<style lang="stylus" scoped>
#best-price
  position relative
  float left
  width 100%
  height 500px
  background-image url('../assets/images/image2.jpg')
  background-size cover

  .overlay
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color rgba(black, .6)

    .content
      width 1366px
      height 100%
      margin 0 auto

      .text
        float left
        width 600px
        height 100%
        display flex
        align-items flex-start
        justify-content center
        flex-direction column

        .title
          font-size 40px
          font-weight 800
          text-transform uppercase
          font-family 'Poppins', sans-serif
          text-align left
          color white
          margin 0

        .description
          text-align left
          color white

        button
          cursor pointer
          border solid 2px white
          background-color transparent
          color white
          padding 15px
          font-size 15px
          font-weight 800
          text-transform uppercase
          font-family 'Poppins', sans-serif

@media (max-width: 1366px)
  #best-price
    .overlay
      .content
        width 100%
        padding 0 20px
        box-sizing border-box

        .text
          width 100%
</style>



// WEBPACK FOOTER //
// src/components/BestPrice.vue